import { useContext } from "react";
import { ExteriorContext } from "../state/contexts";

function useExterior() {
  return useContext(ExteriorContext);
}

export default useExterior;
